export default __webpack_public_path__ + "static/media/snowuns-mobile-characters.79cf04f8.webp";